export default __webpack_public_path__ + "media/zurb/img/about/culture/culture-image1-53131d7b4db5b7b937eb56f2e6c1840b.png";